<template>
  <div>
    <van-popup
      class="full-width full-height"
      v-model="isShow"
      position="right"
      :close-on-popstate="true"
    >
      <div>
        <ld-header @click-left="toggle">
          {{ title }}
        </ld-header>
        <div
          v-for="(airport,i) in orderlist"
          :key="i"
        >
          <div class="font18">
            <img :src="airport.logo">
            <span style="margin: 10px 9px 0px 10px;font-size: 12px;">{{ airport.airlineName }}</span>
            <span style="font-size: 14px;">
              <span v-if="airport.internation == 0">{{ $t('A015','国际') }}</span>
              <span v-if="airport.internation == 1">{{ $t('A014','国内') }}</span>/{{ airport.airlineGt }}</span>
            <span @click="call(airport.airlineTel)">
              {{ airport.airlineTel }}
              <i class="iconfont icon-dianhua1 colorHuang" />
            </span>
          </div> 
        </div>
      </div>
      <ld-no-more />
    </van-popup>
  </div>
</template>
<script>
import {Popup ,Panel ,NoticeBar,Tab, Tabs } from 'vant'
import ldHeader from 'Common/ldHeader'
import ldNoMore from 'Common/ldNoMore'

export default {
  name:'Taxi',
  data() {
    return {
      isShow:false,
      isShowBus:false,
      isShowSubway:false,
      active: '1', //   1 大巴 2 地铁
      orderlist: [],
      parkDetail: '',
      id:'',
    }
  },
  components:{
    [Popup.name]:Popup,
    [Panel.name]:Panel,
    [NoticeBar.name]:NoticeBar,
    [Tab.name]:Tab,
    [Tabs.name]:Tabs,
    ldHeader,
    ldNoMore
  },
  props:{
    title:{
      type:String,
      default:''
    },
    threeCode:{//三字码
      type:String,
      default:''
    },
    terminal:{//航站楼
      type:String,
      default:'T1'
    }
  },
  computed:{
  },
  methods:{
    init(){
      this.getCarList()
    },
    getCarList() {
      this.$api['tkStrategy/queryApAirlineInfo']({
        threeCode: this.threeCode,
        terminal: this.terminal,
      }).then(resp=> {
        this.orderlist = resp.data
        if(this.orderlist.internation == 0) { //国际
          this.orderlist.internation == this.$t('A015','国际')
        } else if(this.orderlist.internation == 1) { //国内
          this.orderlist.internation == this.$t('A014','国内')
        }
      })
    },
    toggle(){
      this.isShow=!this.isShow
      if(this.isShow){
        this.init()
      }
    },
  },
}
</script>
<style lang="less" scoped>
    .pad-lr-16{
        padding:0 16px;
    }
</style>